import { request } from './request';
import { DomainDetail, DomainPayload, TrackingType } from '@dev/ee-api/ee-api-models';

import { AxiosPromise } from 'axios';

export const loadDomain = (): AxiosPromise<DomainDetail[]> => {
    const { Domain } = request();

    return Domain.domainsGet();
};
export const addDomain = (domain: DomainPayload): AxiosPromise<DomainDetail> => {
    const { Domain } = request();

    return Domain.domainsPost(domain);
};
export const loadSingleDomain = (domainName: string): AxiosPromise<DomainDetail> => {
    const { Domain } = request();
    return Domain.domainsByDomainGet(domainName);
};
export const verifyDomain = (domainName: string): AxiosPromise<DomainDetail> => {
    const { Domain } = request();
    return Domain.domainsByDomainVerificationPut(domainName, TrackingType.Http);
};
export const deleteSingleDomain = (domainName: string): AxiosPromise<void> => {
    const { Domain } = request();
    return Domain.domainsByDomainDelete(domainName);
};
export const updateDomain = (domainName: string, body: DomainDetail): AxiosPromise<DomainDetail> => {
    const { Domain } = request();
    return Domain.domainsByDomainPut(domainName, body);
};
export const setAsDefaultSender = (domain: string): AxiosPromise<DomainDetail> => {
    const { Domain } = request();
    return Domain.domainsByEmailIsdefaultPatch(domain);
};
